<template>
    <div id="prog_num_DIV_1" class="row">
        <div id="prog_num_DIV_2" class="col">
            <div id="prog_num_DIV_3">
                <b id="prog_num_B_4">1</b>
                <span>Confirm Info</span>
            </div>
        </div>
        <div id="prog_num_DIV_5" class="col">
            <span id="prog_num_SPAN_6">›</span>
            <div id="prog_num_DIV_7">
                <b id="prog_num_B_8">2</b>
                <span>Choose Protection</span>
            </div>
        </div>
        <div id="prog_num_DIV_9" class="col">
            <span id="prog_num_SPAN_10">›</span>
            <div id="prog_num_DIV_11">
                <b id="prog_num_B_12">3</b>
                <span>Complete Form</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProgressNum"
}
</script>

<style scoped>
#prog_num_DIV_1 {
    border: 0 none #263248;
    box-sizing: border-box;
    color: #263248;
    column-rule-color: #263248;
    display: flex;
    flex-flow: row wrap;
    font: 0.875rem / 1.3125rem "Open Sans", sans-serif;
    height: 3.5rem;
    margin: 0 -0.9375rem;
    outline: #263248 none 0;
    perspective-origin: 25.5rem 1.75rem;
    text-align: left;
    text-decoration: none solid #263248;
    transform-origin: 25.5rem 1.75rem;
}

#prog_num_DIV_2, #prog_num_DIV_5, #prog_num_DIV_9 {
    background: rgba(0, 0, 0, 0) none repeat scroll 0 0 / auto padding-box border-box;
    background-position: 0 0;
    border: 0 none #263248;
    border-radius: 0.625rem;
    bottom: 0;
    box-sizing: border-box;
    color: #263248;
    column-rule-color: #263248;
    display: flex;
    flex-flow: column nowrap;
    font: 0.875rem / 1.3125rem "Open Sans", sans-serif;
    height: 3.5rem;
    left: 0;
    margin: 0 0.9375rem;
    min-height: 0.625rem;
    outline: #263248 none 0;
    overflow-wrap: break-word;
    perspective-origin: 7.5625rem 1.75rem;
    position: relative;
    right: 0;
    text-align: left;
    text-decoration: none solid #263248;
    top: 0;
    transform-origin: 7.5625rem 1.75rem;
}

#prog_num_DIV_3, #prog_num_DIV_7, #prog_num_DIV_11 {
    border: 0 none #263248;
    border-radius: 0.625rem;
    box-sizing: border-box;
    color: #263248;
    column-rule-color: #263248;
    flex-flow: column nowrap;
    font: 700 0.6875rem / 1.0313rem "Open Sans", sans-serif;
    height: 3.5rem;
    min-height: auto;
    min-width: auto;
    outline: #263248 none 0;
    overflow-wrap: break-word;
    padding: 1.25rem 0;
    perspective-origin: 7.5625rem 1.75rem;
    text-align: center;
    text-decoration: none solid #263248;
    transform-origin: 7.5625rem 1.75rem;
}

#prog_num_B_4, #prog_num_B_8, #prog_num_B_12 {
    background: #283246 none repeat scroll 0 0 / auto padding-box border-box;
    border: 0 none #fff;
    border-radius: 2.0625rem;
    box-sizing: border-box;
    color: #fff;
    column-rule-color: #fff;
    font: 700 0.6875rem / 1.0313rem "Open Sans", sans-serif;
    height: 1.6875rem;
    margin: 0 0.9375rem 0 0;
    outline: #fff none 0;
    overflow-wrap: break-word;
    padding: 0.5rem 0.8125rem;
    perspective-origin: 0 0;
    text-align: center;
    text-decoration: none solid #fff;
    transform-origin: 0 0;
    width: 2.5rem;
}

#prog_num_SPAN_6, #prog_num_SPAN_10 {
    border: 0 none #263248;
    bottom: 0.875rem;
    box-sizing: border-box;
    color: #263248;
    column-rule-color: #263248;
    display: block;
    font: 700 1.1875rem / 1.7813rem "Open Sans", sans-serif;
    height: 1.75rem;
    left: -0.9375rem;
    outline: #263248 none 0;
    overflow-wrap: break-word;
    perspective-origin: 0.2188rem 0.875rem;
    position: absolute;
    right: 15.625rem;
    text-align: left;
    text-decoration: none solid #263248;
    top: 0.875rem;
    transform-origin: 0.2188rem 0.875rem;
    width: 0.4375rem;
}

#prog_num_DIV_1:after, #prog_num_DIV_1:before {
    border: 0 none #263248;
    box-sizing: border-box;
    color: #263248;
    column-rule-color: #263248;
    display: block;
    font: 0.875rem / 1.3125rem "Open Sans", sans-serif;
    outline: #263248 none 0;
    text-align: left;
    text-decoration: none solid #263248;
}

#prog_num_DIV_2:after, #prog_num_DIV_5:after, #prog_num_DIV_9:after, #prog_num_DIV_2:before, #prog_num_DIV_5:before, #prog_num_DIV_9:before {
    border: 0 none #263248;
    box-sizing: border-box;
    color: #263248;
    column-rule-color: #263248;
    display: block;
    font: 0.875rem / 1.3125rem "Open Sans", sans-serif;
    outline: #263248 none 0;
    overflow-wrap: break-word;
    text-align: left;
    text-decoration: none solid #263248;
}

#prog_num_DIV_3:after, #prog_num_DIV_7:after, #prog_num_DIV_11:after, #prog_num_DIV_3:before, #prog_num_DIV_7:before, #prog_num_DIV_11:before {
    border: 0 none #263248;
    box-sizing: border-box;
    color: #263248;
    column-rule-color: #263248;
    font: 700 0.6875rem / 1.0313rem "Open Sans", sans-serif;
    outline: #263248 none 0;
    overflow-wrap: break-word;
    text-align: center;
    text-decoration: none solid #263248;
}

#prog_num_B_4:after, #prog_num_B_8:after, #prog_num_B_12:after, #prog_num_B_4:before, #prog_num_B_8:before, #prog_num_B_12:before {
    border: 0 none #fff;
    box-sizing: border-box;
    color: #fff;
    column-rule-color: #fff;
    font: 700 0.6875rem / 1.0313rem "Open Sans", sans-serif;
    outline: #fff none 0;
    overflow-wrap: break-word;
    text-align: center;
    text-decoration: none solid #fff;
}

#prog_num_SPAN_6:after, #prog_num_SPAN_10:after, #prog_num_SPAN_6:before, #prog_num_SPAN_10:before {
    border: 0 none #263248;
    box-sizing: border-box;
    color: #263248;
    column-rule-color: #263248;
    font: 700 1.1875rem / 1.7813rem "Open Sans", sans-serif;
    outline: #263248 none 0;
    overflow-wrap: break-word;
    text-align: left;
    text-decoration: none solid #263248;
}

@media (max-width: 768px) {
    #prog_num_DIV_1 div {
        padding: 0;
        display: flex;
    }

    #prog_num_DIV_1 div > div > b {
        display: block;
        margin: 0 auto;
        width: 1.7rem;
        padding: 0.5rem;
    }

    #prog_num_DIV_1 div > div > span {
        display: block;
        margin: 0 auto;
    }
}
</style>